<template>
  <div class="speciality">
    <p class="speciality__name">{{ speciality.name }}</p>
    <div class="speciality__menu">
      <div
          class="speciality__menu-icon"
          :class="{'speciality__menu-icon_active': activeMenu === speciality.id}"
          :id="speciality.id"
          @click="openMenu(speciality.id)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
              stroke="#858585" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path
              d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
              stroke="#858585" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path
              d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
              stroke="#858585" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="speciality__menu-block" v-if="activeMenu === speciality.id">
        <div class="speciality__menu-btn-wrapper">
          <div class="speciality__menu-btn speciality__menu-btn_edit"
               @click="$emit('openEditSpecialtyPopup', speciality)">
            <Pencil />
            <p class="speciality__menu-btn-name">Редактировать</p>
          </div>
        </div>
        <div class="speciality__menu-btn-wrapper">
          <div class="speciality__menu-btn speciality__menu-btn_delete"
               @click="deleteSpecialty">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 7.33398H6.55556H19" stroke="#DD4646" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.4446 7.33377V18.2227C17.4446 18.6352 17.2807 19.0309 16.9889 19.3226C16.6972 19.6143 16.3016 19.7782 15.889 19.7782H8.11122C7.69866 19.7782 7.303 19.6143 7.01128 19.3226C6.71955 19.0309 6.55566 18.6352 6.55566 18.2227V7.33377M8.889 7.33377V5.77821C8.889 5.36565 9.05289 4.96999 9.34461 4.67827C9.63633 4.38654 10.032 4.22266 10.4446 4.22266H13.5557C13.9682 4.22266 14.3639 4.38654 14.6556 4.67827C14.9473 4.96999 15.1112 5.36565 15.1112 5.77821V7.33377" stroke="#DD4646" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>


            <p class="speciality__menu-btn-name">Удалить</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import Pencil from "@/components/Icons/Pencil.vue";

const props = defineProps({
  speciality: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(["deleteSpecialty", "prohibitDelete"]);

const activeMenu = ref(null)
const openMenu = (id) => activeMenu.value = activeMenu.value === id ? null : id

document.addEventListener('click', (e) => {
  const parent = e.target.closest('.speciality__menu-icon')

  if (parent && Number(parent.id) === props.speciality.id) return
  activeMenu.value = null
})

const deleteSpecialty = () => {
  if (props.speciality.can_delete) {
    emit('deleteSpecialty', props.speciality.id)
  } else {
    emit('prohibitDelete')
  }
}
</script>

<style scoped lang="scss">
.speciality {
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px;

  &__name {
    width: 240px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
  }

  &__menu {
    position: relative;
  }

  &__menu-icon {
    cursor: pointer;

    svg:hover path {
      stroke: #000;
    }

    &_active svg path {
      stroke: #000;
    }
  }

  &__menu-block {
    position: absolute;
    top: 27px;
    left: -165px;
    width: 191px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 2px 4px 24px rgba(0, 0, 0, 0.12);
    border: 1px solid $light-gray-1;
    z-index: 2;
  }

  &__menu-btn {
    height: 32px;
    padding: 0 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    &:hover {
      background-color: $light;
    }

    &:active {
      background-color: $light-gray-1;
    }

    &_edit {
      color: $blue;
    }

    &_delete {
      margin-top: 8px;
      color: $red;
    }
  }

  &__menu-btn-name {
    margin-left: 8px;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
